import * as types from "./types";
import { BYTES_IN_MB } from "./constants";

export const mapExtensions: types.mapExtensions = (extensions) =>
  (extensions && extensions.map((ext) => `.${ext}`).join(",")) || "";

export const getExtension: types.getExtension = (filename) => {
  const extension = filename.split(".").pop();

  return extension && extension.toLowerCase();
};

export const getBytesFromMb: types.getBytesFromMb = (mb) => mb * BYTES_IN_MB;

export const getMbFromBytes: types.getMbFromBytes = (bytes) =>
  Number((bytes / BYTES_IN_MB).toFixed(2));
